import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English translations
import enAuth from './translations/en/auth';
import enCommon from './translations/en/common';
import enFooter from './translations/en/footer';
import enProducts from './translations/en/products';
import enProfile from './translations/en/profile';

// Spanish translations
import esAuth from './translations/es/auth';
import esCommon from './translations/es/common';
import esFooter from './translations/es/footer';
import esProducts from './translations/es/products';
import esProfile from './translations/es/profile';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    resources: {
      es: {
        translation: {
          auth: esAuth,
          common: esCommon,
          footer: esFooter,
          products: esProducts,
          profile: esProfile
        }
      },
      en: {
        translation: {
          auth: enAuth,
          common: enCommon,
          footer: enFooter,
          products: enProducts,
          profile: enProfile
        }
      }
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;